module.exports = __webpack_public_path__ + "static/img/22f.ef0a515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22f.jpg
// module id = BXvW
// module chunks = 0